// extracted by mini-css-extract-plugin
module.exports = {"logo":"a10a3f92e9--logo--ExBfS","img":"a10a3f92e9--img--uW00W","label":"a10a3f92e9--label--fkXoU"};